import script from "./currencies.vue?vue&type=script&lang=js"
export * from "./currencies.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__